import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse } from "../../../types/APIResponse";
import api, { apiWithFormDataMethods } from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { Courier, CourierStatus, DeleteCourier } from "../../../types/CourierTypes";

// Async Thunks
export const fetchCouriers = createAsyncThunk<Courier[], { status?: CourierStatus }, { rejectValue: string }>("couriers/fetchCouriers", async ({ status }, { rejectWithValue }) => {
  try {
    const response = await api.get<ApiResponse<Courier[]>>(apiEndpoints.courier.getAll, {
      params: {
        status
      }
    });
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to fetch couriers.");
    }
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const createCourier = createAsyncThunk<Courier, { formData: FormData }, { rejectValue: string }>("couriers/createCourier", async ({ formData }, { rejectWithValue }) => {
  try {
    const response = await apiWithFormDataMethods.post<ApiResponse<Courier>>(apiEndpoints.courier.create, formData);
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to add courier.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const deleteCourier = createAsyncThunk<DeleteCourier, { id: string }, { rejectValue: string }>("couriers/deleteCourier", async ({ id }, { rejectWithValue }) => {
  try {
    const response = await api.delete<ApiResponse<DeleteCourier>>(`${apiEndpoints.courier.delete}/${id}`);
    if (response?.success) {
      return { ...response.data, id };
    } else {
      throw new Error(response.message || "Failed to delete courier.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updateCourier = createAsyncThunk<Courier, { id: string; formData: FormData }, { rejectValue: string }>("couriers/updateCourier", async ({ id, formData }, { rejectWithValue }) => {
  try {
    const response = await apiWithFormDataMethods.put<ApiResponse<Courier>>(`${apiEndpoints.courier.update}/${id}`, formData);
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to update courier.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});
